import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'

import TextWithCheck from '../../molecules/TextWithCheck'
import BuyIcon from '../../atoms/BuyIcon'
import Subtitle from '../../atoms/Subtitle'
import LinkButton from '../../atoms/LinkButton'
import medias from '../../../util/medias'

const Description = styled(Subtitle)`
  margin-left: 8px;
  line-height: ${14 * 1.5}px;
  font-size: 14px;
  font-size: calc(12px + (14 - 12) * ((100vw - 360px) / (1024 - 360)));
  ${medias.fontMax`font-size: 14px;`};
  ${medias.fontMin`font-size: 12px;`};
`

const Content = styled(View)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  margin-top: 8px;
`

const Itens = styled(View)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Row = styled(View)`
  margin-top: 16px;
`

const CallToBuy = ({ onClick }) => (
  <Content>
    <BuyIcon />
    <Title>Veja o que você pode comprar</Title>
    <Itens>
      <Row>
        <TextWithCheck
          render={() => <Description>Maior variedade de produtos do mercado.</Description>}
        />
      </Row>
      <Row>
        <TextWithCheck
          render={() => <Description>Milhares de anúncios novos todos os dias.</Description>}
        />
      </Row>
      <Row>
        <TextWithCheck
          render={() => <Description>Compra por perto. É rápido e prático.</Description>}
        />
      </Row>
    </Itens>
    <Row>
      <LinkButton
        href="https://www.olx.com.br/brasil"
        text="Ver ofertas"
        width="180px"
        height="48px"
        inverted
        onClick={onClick}
      />
    </Row>
  </Content>
)

CallToBuy.propTypes = {
  onClick: PropTypes.func,
}

export default CallToBuy
